import React from "react";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import { deepCopy } from "../../components/Common";

export const getAddress = ({ BusinessDetails, isBillingAddress, props }) => {
    if (BusinessDetails.Address.Street === BusinessDetails.SalesForceData.Account.BillingAddress.street) {
        isBillingAddress = true;
    } else if (BusinessDetails.Address.Street === BusinessDetails.SalesForceData.Account.ShippingAddress.street) {
        isBillingAddress = false;
    }

    return (
        <SegmentedButtonGroup
            tight
            label="Preferred Address"
            ButtonGroupStyle={{
                flexWrap: "wrap",
            }}
            style={{ flex: "none" }}
            value={isBillingAddress ? "Billing Address" : "Shipping Address"}
            items={["Billing Address", "Shipping Address"]}
            onChange={(e, value) =>
                updateAddress(e, value, {
                    BusinessDetails,
                    props,
                })
            }
            helperText={"*If these address details need to change please contact your Account Manager"}
        />
    );
};

export const updateAddress = (e, value, { BusinessDetails, props }) => {
    let val = value ? value : e;
    if (val?.target?.value) val = e?.target?.value;

    let newBusinessDetails = deepCopy(BusinessDetails);

    if (val === "Billing Address") {
        newBusinessDetails.Address.Street = BusinessDetails.SalesForceData.Account.BillingAddress.street;
        newBusinessDetails.Address.Suburb = BusinessDetails.SalesForceData.Account.BillingAddress.city;
        newBusinessDetails.Address.State = BusinessDetails.SalesForceData.Account.BillingAddress.state;
        newBusinessDetails.Address.PostCode = BusinessDetails.SalesForceData.Account.BillingAddress.postalCode;
        newBusinessDetails.Address.FormattedAddress =
            newBusinessDetails.Address.Street +
            ", " +
            newBusinessDetails.Address.Suburb +
            " " +
            newBusinessDetails.Address.State +
            ", Australia";
    } else if (val === "Shipping Address") {
        newBusinessDetails.Address.Street = BusinessDetails.SalesForceData.Account.ShippingAddress.street;
        newBusinessDetails.Address.Suburb = BusinessDetails.SalesForceData.Account.ShippingAddress.city;
        newBusinessDetails.Address.State = BusinessDetails.SalesForceData.Account.ShippingAddress.state;
        newBusinessDetails.Address.PostCode = BusinessDetails.SalesForceData.Account.ShippingAddress.postalCode;
        newBusinessDetails.Address.FormattedAddress =
            newBusinessDetails.Address.Street +
            ", " +
            newBusinessDetails.Address.Suburb +
            " " +
            newBusinessDetails.Address.State +
            ", Australia";
    }

    if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
};

export const updateNewUserBusiness =
    (param) =>
    (e, value, { BusinessDetails, props, validationSchema, checkJobStateValidationSchema, errorState }) => {
        let newBusinessDetails = deepCopy(BusinessDetails);
        let val =
            value !== undefined
                ? value
                : e && e.target && e.target.value !== undefined
                ? e.target.value
                : e !== null && e !== undefined
                ? e
                : null;

        // If parameter includes dot notation (indicating a nested property)
        if (param.includes(".")) {
            const keys = param.split("."); // Split the nested keys
            let nestedObject = newBusinessDetails;

            // Traverse through the nested keys, creating nested objects if they don't exist
            for (let i = 0; i < keys.length - 1; i++) {
                if (!nestedObject[keys[i]]) {
                    // Create a new nested object if it doesn't exist
                    nestedObject[keys[i]] = {};
                }
                nestedObject = nestedObject[keys[i]];
            }

            // Update the value of the nested property
            nestedObject[keys[keys.length - 1]] = val;
        } else {
            // If not a nested property, update the value directly
            newBusinessDetails[param] = val;

            // Additional logic for "id" parameter
            if (param === "id") {
                newBusinessDetails["Code"] = val;
            }
        }

        // Call the UpdateBusiness function if provided
        if (props.UpdateBusiness) {
            props.UpdateBusiness(newBusinessDetails);
        }

        // Validate using customer validation schema
        if (validationSchema?.Distributor?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Distributor", null, param, val);
            let newErrorState = deepCopy(errorState);
            newErrorState[param] = error;

            // Additional validation logic for "id" parameter
            if (param === "id") {
                error = checkJobStateValidationSchema(validationSchema, "Distributor", null, "Code", val);
                newErrorState["Code"] = error;
            }

            // Set the error state
            setErrorState(newErrorState);
        }
    };

export const setErrorState = ({ state, props }) => {
    if (props.SetErrorState) props.SetErrorState(state);
};

export const updateMarkup = ({ key, param, value, BusinessDetails, props }) => {
    let newBusinessDetails = deepCopy(BusinessDetails);
    newBusinessDetails.MarkupStructure.Markups[key][param] = value;
    if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
};

export const deleteMarkup = ({ key, BusinessDetails, setShowMessage, setDeleteKey, props }) => {
    // Check to ensure there is aleast one markup

    if (Object.keys(BusinessDetails.MarkupStructure.Markups).length > 1) {
        let newBusinessDetails = deepCopy(BusinessDetails);
        // Change default markup if it was deleted or markup is null
        delete newBusinessDetails.MarkupStructure.Markups[key];

        // Check if default markup was deleted or doesn't exist in the list of markups, set to next markup available
        if (
            key === newBusinessDetails.MarkupStructure.MarkupDefault ||
            !Object.keys(newBusinessDetails.MarkupStructure.Markups).includes(
                newBusinessDetails.MarkupStructure.MarkupDefault
            )
        ) {
            let nextMarkup = Object.keys(newBusinessDetails.MarkupStructure.Markups)[0];
            newBusinessDetails.MarkupStructure.MarkupDefault = nextMarkup;
            setShowMessage({
                message: "Default Markup was deleted or changed, default changed to: " + nextMarkup,
                type: "warning",
            });
        }
        setDeleteKey(null);
        if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
    } else {
        setDeleteKey(null);
        setShowMessage({ message: "Please add another Markup before removing all Markups.", type: "error" });
    }
};

export const addMarkup = ({ key, props, seNewMarkup, BusinessDetails }) => {
    if (key === "") return;
    if (BusinessDetails.MarkupStructure.Markups[key]) return;
    let newBusinessDetails = deepCopy(BusinessDetails);
    newBusinessDetails.MarkupStructure.Markups[key] = {
        DisplayName: key,
        Material: 100,
        Installation: 100,
        PackingAndDel: 0,
        Commission: 0,
    };
    if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
    seNewMarkup("");
};

export const updatePaymentStructure = ({ param, value, BusinessDetails, props }) => {
    const newBusinessDetails = deepCopy(BusinessDetails);
    newBusinessDetails.MarkupStructure.PaymentStructure[param] = value;

    const finalPaymentPercent = calcFinalProgressPaymentPercent(newBusinessDetails.MarkupStructure.PaymentStructure);
    newBusinessDetails.MarkupStructure.PaymentStructure["SupplyOnlyDeposit"] = finalPaymentPercent;

    if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
};

export const calcFinalProgressPaymentPercent = (paymentStructure) => {
    const { Deposit = 0, Progress1 = 0, Progress2 = 0, Progress3 = 0 } = paymentStructure;

    if (
        typeof Deposit !== "number" ||
        typeof Progress1 !== "number" ||
        typeof Progress2 !== "number" ||
        typeof Progress3 !== "number"
    ) {
        return "- ";
    }

    if (Deposit < 0 || Progress1 < 0 || Progress2 < 0 || Progress3 < 0) {
        return "- ";
    }

    const percent = 100 - Deposit - Progress1 - Progress2 - Progress3;
    return percent <= 0 ? "- " : percent;
};
